import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputComponent } from '../../../../components/InputComponent';
import * as generic from '../../../../components/Generico';
import { PersonaExpuesta } from '../../../../models/trust/cliente/PersonaExpuesta';
import { ClientePnService } from '../../../../service/trust/ClientePnService';
import { BottomActionBar } from '../../../../components/ui/BottomActionBar';
import { Divider } from 'primereact/divider';
import { useSubmitForm } from '../../../../hooks/useSubmitForm';

export const Declaracion = ({ toast, id, permss, catalogos, nuevoCliente, setDialogAnexos, handlePrev, soloLectura }) => {
    const omodel = new PersonaExpuesta();
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError } = useForm({ defaultValues, shouldTrim: true });
    const clienteServicio = new ClientePnService();
    const { funcMessageBlobError, downloadPdf } = generic.Generico();
    const { inDrop, inText, inDropMultiple, inArea } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const { enviarFormulario } = useSubmitForm({
        toast, setError, onSuccess: (res) => {
            // Atrapamos la respuesta del backend y actualizamos el estado de la vista
            if (res?.data?.estado) {
                nuevoCliente({ nemonico: res.data.estado }); // En el flujo solo se envia 'ENVIADO'
            }
        }
    });
    // Estados locales
    const [load, setLoad] = useState(false);
    const [loadReport, setLoadReport] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [anexosRequisitos, setAnexosRequisitos] = useState([]);
    // Estados para visibilidad condicional PEP
    const [esPep, setEsPep] = useState(false);
    const [esRelacionPep, setEsRelacionPep] = useState(false);
    const [esEeuu, setEsEeuu] = useState(false);
    const [esExtranjero, setEsExtranjero] = useState(false);
    const [tieneCertificacionNatural, setTieneCertificacionNatural] = useState(false);
    // const [tieneCertificacionControl, setTieneCertificacionControl] = useState(false);

    useEffect(() => {
        editFicha();
    }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

    const editFicha = () => {
        setIsLoading(true);
        clienteServicio.consultarCliente(id, { seccion: 'seccion5' }).then(res => {
            if (res.data.anexos_requisitos !== undefined) setAnexosRequisitos(res.data.anexos_requisitos);
            setTieneCertificacionNatural(res.data.tiene_certificacion_natural || false);
            // setTieneCertificacionControl(res.data.tiene_certificacion_control || false);
            const _cli = res.data.cliente;
            if (!_cli) { reset(defaultValues); return; }

            if (_cli.origen_fondo) {
                _cli.origen_fondo = catalogos.origen_fondo.filter(item => _cli.origen_fondo.includes(item.cat_id));
            }

            setEsPep(_cli.pep?.cat_id === true);
            setEsRelacionPep(_cli.relacion_pep?.cat_id === true);
            setEsEeuu(_cli.eeuu_fin_fiscal?.cat_id === true);
            setEsExtranjero(_cli.extranjero_fin_fiscal?.cat_id === true);
            reset(generic.renewValues(_cli, omodel.model));
        }).finally(() => setIsLoading(false));
    }

    const onSubmit = (data) => {
        data.id = id;
        data.seccion = 'seccion5';
        setLoad(true);
        clienteServicio.editarCliente(data).then(res => {
            generic.funcSuccess(res, toast);
            nuevoCliente({
                nemonico: res.data.nemonico,
                necesita_ac_control: res.data.necesita_ac_control,
                necesita_ac_natural: res.data.necesita_ac_natural
            });
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setLoad(false));
    }

    const onChangePep = (e) => {
        setEsPep(e.value?.cat_id === true);
    }

    const onChangeRelacionPep = (e) => {
        setEsRelacionPep(e.value?.cat_id === true);
    }

    const onChangeEeuu = (e) => {
        setEsEeuu(e.value?.cat_id === true);
    }

    const onChangeExtranjero = (e) => {
        setEsExtranjero(e.value?.cat_id === true);
    }

    const generarReporte = (opcion = '') => {
        setLoadReport(true);
        clienteServicio.descargar(id, { tipo: opcion }).then(res => {
            const nameFile = opcion === 'declaracion' ? `${id}-Declaracion-Licitud-Fondos.pdf` : `${id}-Formulario-Informacion-Cliente.pdf`;
            downloadPdf(res, nameFile);
        }).catch(error => {
            funcMessageBlobError('Complete la información antes de generar.', error, toast);
        }).finally(() => setLoadReport(false));
    }

    const subirReporte = () => { if (setDialogAnexos) setDialogAnexos(true); }

    const enviar = () => {
        enviarFormulario(id, 'ficha/trust/cliente-pn/enviar', 'clientePn');
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores en la validación.', life: 3000 });
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">

            <Panel header={generic.renderPanelHeader('J', 'ORIGEN DE LOS FONDOS/BIENES', 'pi pi-money-bill')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">
                    {inDropMultiple('origen_fondo', catalogos?.origen_fondo, { lab: 'nombre' }, 12)}
                    {inArea('fondo_detalle', 3, 100, 12)}
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('K', 'DECLARACIÓN SOBRE LA CONDICIÓN DE PERSONA EXPUESTA POLÍTICAMENTE', 'pi pi-users')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">

                    {inDrop('pep', generic.estadosSiNo, { lab: 'nombre', chn: onChangePep, val: true }, 12)}
                    {esPep && inText('cargo_pep', { icon: 'pi pi-briefcase' }, 6)}
                    {esPep && inText('tiempo_pep', { icon: 'pi pi-clock' }, 6)}

                    <Divider type="dashed" className="my-2" />

                    {inDrop('relacion_pep', generic.estadosSiNo, { lab: 'nombre', chn: onChangeRelacionPep, val: true }, 12)}

                    {esRelacionPep && (
                        <>
                            {inText('nombre_pep', { icon: 'pi pi-user' }, 6)}
                            {inText('tipo_relacion_pep', { icon: 'pi pi-sitemap' }, 6)}
                            {inText('cargo_nombre_pep', { icon: 'pi pi-briefcase' }, 6)}
                            {inText('tiempo_nombre_pep', { icon: 'pi pi-clock' }, 6)}
                        </>
                    )}
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('L', 'DECLARACIÓN SOBRE ORIGEN Y DESTINO LÍCITO DE RECURSOS', 'pi pi-file-edit')} className="panel-ficha shadow-1 mb-4">
                <div className="p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 m-2">
                    <div className="flex align-items-center gap-2 mb-3">
                        <i className="pi pi-info-circle text-blue-600 text-lg"></i>
                        <span className="font-bold text-blue-900">Términos de la Declaración</span>
                    </div>
                    {omodel.msgOrigen}
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('M', 'AUTORIZACIÓN DE ACCESO DE INFORMACIÓN', 'pi pi-lock')} className="panel-ficha shadow-1 mb-4">
                <div className="p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 m-2">
                    <div className="flex align-items-center gap-2 mb-3">
                        <i className="pi pi-shield text-blue-600 text-lg"></i>
                        <span className="font-bold text-blue-900">Autorización</span>
                    </div>
                    {omodel.msgAcceso}
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('N', 'DECLARACIÓN DE DOMICILIO FISCAL', 'pi pi-globe')} className="panel-ficha shadow-1 mb-4">
                <div className="p-3 mb-3 text-justify line-height-3 text-800 bg-indigo-50 border-round border-left-3 border-indigo-500 mx-2">
                    <div className="flex align-items-center gap-2 mb-2">
                        <i className="pi pi-exclamation-triangle text-indigo-600 text-lg"></i>
                        <span className="font-bold text-indigo-900">Importante</span>
                    </div>
                    <span>
                        Si responde <strong>"SÍ"</strong> a cualquiera de las siguientes preguntas sobre fines fiscales, deberá completar la <strong>Auto-certificación</strong> correspondiente.
                        <br className="hidden md:block" />
                        <span className="text-indigo-700 font-medium">
                            <i className="pi pi-info-circle mr-1 text-sm"></i>
                            Para acceder a ella, haga clic en <strong>Guardar</strong> y se habilitará una <strong>nueva pestaña</strong>.
                        </span>
                    </span>
                </div>
                <div className="formgrid grid mb-3">
                    {inDrop('eeuu_fin_fiscal', generic.estadosSiNo, {
                        lab: 'nombre', chn: onChangeEeuu, // Bloquear si tiene certificación
                        ne: tieneCertificacionNatural ? true : undefined,
                        // Mostrar mensaje de ayuda explicando por qué está bloqueado
                        helpText: tieneCertificacionNatural ? "No se puede editar este campo porque ya existe una auto-certificación generada para este cliente." : null
                    }, esEeuu ? 6 : 12)}
                    {esEeuu && inText('eeuu_identificacion', { icon: 'pi pi-id-card' }, 6)}

                    <Divider type="dashed" className="my-2" />

                    {inDrop('extranjero_fin_fiscal', generic.estadosSiNo, {
                        lab: 'nombre', chn: onChangeExtranjero, val: true, // Bloquear si tiene certificación
                        ne: tieneCertificacionNatural ? true : undefined,
                        // Mostrar mensaje de ayuda explicando por qué está bloqueado
                        helpText: tieneCertificacionNatural ? "No se puede editar este campo porque ya existe una auto-certificación generada para este cliente." : null
                    }, esExtranjero ? 6 : 12)}
                    {esExtranjero && inText('extranjero_identificacion', { icon: 'pi pi-id-card' }, 6)}

                    {/* Autocertificación de control oculta */}
                    {/* <Divider type="dashed" className="my-2" />
                    {inDrop('enf_inversion', generic.estadosSiNo, {
                        lab: 'nombre',
                        // Bloquear si tiene certificación
                        ne: tieneCertificacionControl ? true : undefined,
                        // Mostrar mensaje de ayuda explicando por qué está bloqueado
                        helpText: tieneCertificacionControl ? "No se puede editar este campo porque ya existe una certificación generada para este cliente." : null
                    }, 12)} */}
                </div>

                <div className="p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mx-2 mb-2">
                    <div className="flex align-items-center gap-2 mb-3">
                        <i className="pi pi-verified text-blue-600 text-lg"></i>
                        <span className="font-bold text-blue-900">Certificación</span>
                    </div>
                    {omodel.msgDeclaracion}
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('', 'AUTORIZACIÓN PARA TRATAMIENTO DE DATOS', 'pi pi-lock')} style={{ width: '100%', margin: 'auto' }} className="panel-ficha shadow-1 mb-4">
                <div className="field col p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500">
                    <div className="flex align-items-center gap-2 mb-3">
                        <i className="pi pi-shield text-blue-600 text-lg"></i>
                        <span className="font-bold text-blue-900">Tratamiento de Datos Personales</span>
                    </div>
                    {omodel.msgTratamientoDatos}
                </div>
            </Panel>

            {anexosRequisitos.length > 0 && (
                <Panel header={generic.renderPanelHeader('', 'ANEXOS REQUERIDOS', 'pi pi-paperclip')} className="panel-ficha shadow-1 mb-4">
                    <div className="p-3 text-justify line-height-3 text-700 bg-yellow-50 border-round border-left-3 border-yellow-500 m-2">
                        <div className="flex align-items-center gap-2 mb-3">
                            <i className="pi pi-folder-open text-yellow-600 text-lg"></i>
                            <span className="font-bold text-yellow-900">Documentos que debe adjuntar</span>
                        </div>
                        <ul className="pl-4 m-0">
                            {anexosRequisitos.map((req, index) => (
                                <li key={index} className="mb-2">{req}</li>
                            ))}
                        </ul>
                    </div>
                </Panel>
            )}

            <BottomActionBar layoutVersion="v2" onPrev={handlePrev} onSave={true} onGenerate={() => generarReporte()} onSend={enviar} onAttachments={subirReporte} loading={load || loadReport}
                isReadOnly={soloLectura} enableExtras={id != null}
                customButtons={soloLectura ? [] : [
                    {
                        label: loadReport ? 'Generando...' : 'Licitud Fondo',
                        icon: 'pi pi-print',
                        onClick: () => generarReporte('declaracion'),
                        loading: load || loadReport,
                        className: 'p-button-secondary'
                    }
                ]}
            />
        </form>
    );
}
